import { isAxiosError } from 'axios';

export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (isAxiosError(error)) {
    const data = error.response?.data;
    if (
      typeof data === 'object' &&
      data !== null &&
      'message' in data &&
      typeof data.message === 'string' &&
      data.message.length > 0
    ) {
      return data.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
};

export const isResourceNotFoundError = (error: unknown): boolean => {
  if (isAxiosError(error) && error.response?.status === 404) {
    return true;
  }

  return getApiErrorMessage(error, '')
    .toLowerCase()
    .includes('resource not found');
};
